/* WCAG 2.2 AA, part 1 of 2. MUST load BEFORE wcc.js.
 *
 * Both scripts are deferred, so document order decides execution order. This
 * file wraps setInterval before wcc.js ever calls it, which is the only way to
 * reach the review carousel's timer without editing minified vendor code.
 *
 * 2.2.2 Pause, Stop, Hide: wcc.js runs setInterval(go, 6500) on the review
 * carousel. The theme's prefers-reduced-motion block only zeroes CSS animation
 * duration and cannot stop a JS timer, so reviews kept swapping every 6.5s for
 * readers who had explicitly asked for no motion. There was also no pause
 * control of any kind.
 */
(function () {
  'use strict';

  var timers = [];
  var native = window.setInterval;

  window.setInterval = function (fn, delay) {
    var id = native.apply(window, arguments);
    if (typeof delay === 'number' && delay >= 2000 && delay <= 20000) {
      timers.push({ id: id, fn: fn, delay: delay });
    }
    return id;
  };

  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var paused = false;

  function stopAll() {
    timers.forEach(function (t) {
      if (t.id !== null) { clearInterval(t.id); t.id = null; }
    });
    paused = true;
  }

  function startAll() {
    timers.forEach(function (t) {
      if (t.id === null) t.id = native.call(window, t.fn, t.delay);
    });
    paused = false;
  }

  function label(btn) {
    btn.textContent = paused ? 'Play' : 'Pause';
    btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    btn.setAttribute('aria-label', paused
      ? 'Play the automatically rotating reviews'
      : 'Pause the automatically rotating reviews');
  }

  function mountControl() {
    if (!timers.length) return;
    var host = document.querySelector('.wcc-fc-controls, .wcc-car-controls');
    if (!host) {
      var car = document.querySelector('[class*="wcc-fc"], [class*="wcc-car"]');
      if (!car) return;
      host = document.createElement('div');
      host.style.textAlign = 'center';
      car.appendChild(host);
    }
    if (host.querySelector('.wcc-motion-toggle')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wcc-motion-toggle';
    label(btn);
    btn.addEventListener('click', function () {
      if (paused) startAll(); else stopAll();
      label(btn);
    });
    host.appendChild(btn);
  }

  function init() {
    // Honour the stated preference before the first swap can land.
    if (reduce) stopAll();
    mountControl();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  } else {
    setTimeout(init, 0);
  }
})();
